import { Injectable, inject } from '@angular/core';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import {
  CheckShiftActivityPermissionsService,
  TimelineCellHighlightService,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { firstValueFrom } from 'rxjs';
import { AssignShiftDropZoneHelperService } from '../components-v2/assign-shift-drop-zone-v2/new-shift-drop-zone-helper.service';
import { TimelineCommonOperationsService } from './timeline-common-operations.service';

@Injectable()
export class AssignShiftDropZoneCellViewHelperService {
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly timelineCellHighlightService = inject(
    TimelineCellHighlightService,
  );
  private readonly assignShiftDropZoneHelperService = inject(
    AssignShiftDropZoneHelperService,
  );
  private readonly timelineCommonOperationsService = inject(
    TimelineCommonOperationsService,
  );
  private readonly checkShiftActivityPermissionsService = inject(
    CheckShiftActivityPermissionsService,
  );

  public async onDragOverHandler(userId: string): Promise<void> {
    this.timelineCellHighlightService.clearCellsFromHighlight();

    if (userId) {
      const draggingShift = await firstValueFrom(
        this.dragAndDropModeService.draggingShiftV2$,
      );
      if (draggingShift && userId) {
        this.timelineCellHighlightService.setCellToHighlight(
          userId,
          draggingShift.startDatetime,
        );

        await this.assignShiftDropZoneHelperService.onDragOverHandler(userId);
      }
    }
  }

  public async onDragLeaveHandler(userId: string): Promise<void> {
    await this.assignShiftDropZoneHelperService.onDragLeaveHandler(userId);
    this.timelineCellHighlightService.clearCellsFromHighlight();
  }

  public async onDropHandler(userId: string): Promise<void> {
    const draggingShift = await firstValueFrom(
      this.dragAndDropModeService.draggingShiftV2$,
    );

    await this.checkShiftActivityPermissionsService.checkShiftActivityPermissions(
      {
        shiftIds: [draggingShift?.id as string],
        onSuccess: async () => {
          await this.assignShiftDropZoneHelperService.onDropCellViewHandler(
            userId,
            draggingShift,
          );
        },
        onFailure: () => {
          this.assignShiftDropZoneHelperService.removeDraggingShift(userId);
          this.dragAndDropModeService.setDraggingShiftV2(null);
        },
      },
    );

    this.timelineCellHighlightService.clearCellsFromHighlight();
  }
}
